(() => {
  if (customElements.get('tb-aisle-navigation')) return;
  class AisleNavigation extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const fitMenu = () => {
        const panel = this.querySelector('.tb-aisle-root[open] .tb-aisle-panel');
        if (panel) panel.style.setProperty('--tb-menu-available', `${Math.max(180, window.innerHeight - panel.getBoundingClientRect().top - 16)}px`);
      };
      this.addEventListener('toggle', () => requestAnimationFrame(fitMenu), { signal, capture: true });
      window.addEventListener('resize', fitMenu, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = this.querySelector('[data-top-menu][open]');
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      }, { signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-close-menu]')) {
          const open = event.target.closest('[data-top-menu]');
          open.open = false;
          open.querySelector('summary').focus();
        }
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.querySelectorAll('[data-top-menu][open]').forEach(menu => { menu.open = false; });
      }, { signal });
      if (window.matchMedia('(max-width: 989px)').matches) this.querySelectorAll('.tb-aisle-department[open]').forEach(aisle => { aisle.open = false; });
    }
    disconnectedCallback() { this.abort.abort(); }
  }
  customElements.define('tb-aisle-navigation', AisleNavigation);
})();
